import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 200.000000 200.000000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200.000000 200.000000\" preserveAspectRatio=\"xMidYMid meet\" id=\"icon-add\">\r\n\r\n<g transform=\"translate(0.000000,200.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\">\r\n<path d=\"M1000 1335 l0 -335 -335 0 -335 0 0 -40 0 -40 335 0 335 0 0 -335 0\r\n-335 40 0 40 0 0 335 0 335 335 0 335 0 0 40 0 40 -335 0 -335 0 0 335 0 335\r\n-40 0 -40 0 0 -335z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol